/**
 * Single source of truth for the maintainer / support contact, so the chat
 * FAB, the announcement banner, and the sign-in page all point to the same
 * Teams chat.
 */

export const MAINTAINER_NAME = 'Siqi Zhang'

export const TEAMS_CHAT_URL =
  'https://teams.microsoft.com/l/chat/0/0?users=siqi.zhang@bayer.com&message=Hi%20Siqi%20%E2%80%94%20question%20about%20DACcelerate:'
